export default __webpack_public_path__ + "static/media/exploded-view_labels.92ff17cd.png";